import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

/* Note colormaps have a "definition", which is a JSON field. Right now I believe
   this is only used by the backend, and its definition is a bit convoluted.
   So we ignore it for now.
 */

export const colormapSchema = z.object({
  name: z.string() /* Unique, used as slug */,
  description: z.string().nullable(),
  definition: z.record(z.any()),
});

export const colormapListSchema = paginatedSchema(colormapSchema);

export type Colormap = z.infer<typeof colormapSchema>;
export type ColormapList = z.infer<typeof colormapListSchema>;

export function useColormaps(params = {}) {
  const url = combineUrlAndParams("/api/v4/colormaps/", params);
  return useParsedQuery<ColormapList>(
    ["lizard-api-v4", "colormaps", url],
    () => fetchWithError(url),
    (json: unknown) => colormapListSchema.parse(json)
  );
}

export function useColormap(name: string) {
  return useParsedQuery<Colormap>(
    ["lizard-api-v4", "colormaps", name],
    () => fetchWithError(`/api/v4/colormaps/${name}/`),
    (json: unknown) => colormapSchema.parse(json)
  );
}
